import { useQuery } from "./urqlHooks";

const INITIALBALANCES = `query INITIAL_BALANCES($companyId: String!) {
	allBankBalances(companyId: $companyId) {
		bankId
		availableBalance
		amountApproved
		amountUsed
		creditLineAvailable
		currencyType
		accountNumber
		createdAt
    accountType
    isActive
    includeInCashFlow
    passwordId
	}
}`;

export const GetInitialBalances = (companyId) => {
  const [result, reexecuteQuery] = useQuery({
    query: INITIALBALANCES,
    variables: { companyId },
  });
  const { data, fetching, error } = result;
  return {
    data,
    fetching: !companyId ? false : fetching,
    error,
    reexecuteQuery,
  };
};

const MANUALDOCUMENTS = `query MANUAL_DOCUMENTS($companyId: String!) {
	allInitialBalanceDocumentsByCompany(companyId: $companyId) {
		name
		description
		amount
		documentDate
    currencyType
    id
    meta {
      ... on InitialBalanceMeta {
        isBanking
        includeInCashFlow
      }
    }
	}
}`;

export const GetManualDocuments = (companyId) => {
  const [result, reexecuteQuery] = useQuery({
    query: MANUALDOCUMENTS,
    variables: { companyId },
  });
  const { data, fetching, error } = result;
  return {
    data,
    fetching: !companyId ? false : fetching,
    error,
    reexecuteQuery,
  };
};

const LAST_BANK_UPDATE = `query LAST_BANK_UPDATED($companyId: String!) {
	lastBankUpdated(companyId: $companyId) {
		createdAt
	}
}`;

export const GetLastBankUpdated = (companyId) => {
  const [result, reexecuteQuery] = useQuery({
    query: LAST_BANK_UPDATE,
    variables: { companyId },
  });
  const { data, fetching, error } = result;
  return {
    data,
    fetching: !companyId ? false : fetching,
    error,
    reexecuteQuery,
  };
};